import { render } from "./CleAddNewSpecimen.vue?vue&type=template&id=41329036"
import script from "./CleAddNewSpecimen.vue?vue&type=script&lang=js"
export * from "./CleAddNewSpecimen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__